import { NgModule } from '@angular/core';
import { BloodtypeAddComponent } from './bloodtype-add.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
    imports: [CommonModule, IonicModule, TranslateModule],
    exports: [BloodtypeAddComponent],
    declarations: [BloodtypeAddComponent],
    providers: [],
})
export class BloodtypeAddModule { }
